import React, { useEffect, useState } from "react";
import { Box, TextField, Button, Typography, Modal, FormControl, InputLabel, Input, IconButton, CircularProgress } from "@mui/material";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import CustomButton from "../../Components/Common/CustomButton";
import TextInput from "../../Components/Common/TextInput";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";
import { toast } from "react-toastify";

function ProfilePage() {

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userName = loginData?.user?.user
  const userEmail = loginData?.user?.email
  const userPassword = loginData?.user?.password
  const token = loginData?.token
  const [inputValues, setInputValues] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState([])
  const [loading, setLoading] = useState(false);
  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setInputValues({
          name: response.data.data.user || "",
          email: response.data.data.email || "",
          password: "",
        });
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      toast.error("Failed to load profile data.");
    } finally {
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [token]);

  const handleChange = (field, value) => {
    setInputValues((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleUpdate = async () => {
    setLoading(true)
    try {
      let payload = {
        user: inputValues.name,
        email: inputValues.email,
      };

      if (inputValues.password) {
        payload.password = inputValues.password;
      }

      const response = await axios.put(`${BASE_URL}/user/profile`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' },
        });
        fetchProfile()
      } else if (response?.data?.error) {
        setErrors(response?.data?.error)
      }
    } catch (error) {
      console.error("Error updating profile:", error?.response);
      setErrors(error?.response?.data?.error)
    } finally {
      setLoading(false)
    }
  };

  const getErrorMessage = (field) => {
    const fieldError = errors?.find((err) => err?.path === field);
    return fieldError?.msg || null;
  };

  const clearErrorMessage = (field) => {
    setErrors((prevErrors) => prevErrors?.filter((err) => err?.path !== field));
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        handleUpdate()
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [inputValues]);

  return (
    <><Navbar />
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >

        <Box
          sx={{
            width: "40%",
            margin: "50px auto",
            padding: 2,
            backgroundColor: "#fff",
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="h4" sx={{ marginBottom: 3 }}>
            Profile Information
          </Typography>

          <TextInput
            label={"Name"}
            placeholder={"Enter Your Name"}
            type={"default"}
            name={"name"}
            value={inputValues.name}
            onChange={(e) => {
              handleChange("name", e.target.value)
              clearErrorMessage("user");
            }}
          />
          {getErrorMessage("user") && (
            <Box color="red" mb={2}>
              {getErrorMessage("user")}
            </Box>
          )}
          <TextInput
            label={"Email"}
            placeholder={"Enter Your Email..."}
            type={"email"}
            name={"email"}
            value={inputValues.email}
            onChange={(e) => {
              handleChange("email", e.target.value)
              clearErrorMessage("email");
            }}
          />
          {getErrorMessage("email") && (
            <Box color="red" mb={2}>
              {getErrorMessage("email")}
            </Box>
          )}

          <TextInput
            label={"Password"}
            placeholder={"Enter Your Password..."}
            type={"password"}
            name={"password"}
            value={inputValues.password}
            onChange={(e) => {
              handleChange("password", e.target.value)
              clearErrorMessage("password");
            }}
          />
          {getErrorMessage("password") && (
            <Box color="red" mb={2}>
              {getErrorMessage("password")}
            </Box>
          )}

          <CustomButton
            onClick={handleUpdate}
          >
            {loading ? <CircularProgress size={30} sx={{ color: theme.colors.white }} /> : 'Update'}
          </CustomButton>
        </Box>
      </Box>
      <Footer />
    </>
  );
}


export default ProfilePage;
